/**
 * Course detail tabs. `value` is the `:page` segment of
 * `/mini-course/:id/:page?/:subPage?`; `subPage` is the default sub section.
 */
export const COURSE_TABS = [
  { value: 'sections', label: 'Sections' },
  { value: 'landing-page', label: 'Landing page' },
  { value: 'settings', label: 'Settings', subPage: 'general' },
  { value: 'theme', label: 'Theme' },
  { value: 'analytics', label: 'Analytics' },
  { value: 'share', label: 'Share', subPage: 'links' },
]

/** `:page` values rendered by the full-screen editor instead. */
export const EDITOR_PAGES = ['page', 'completion']

export const isEditorRoute = (page, subPage) =>
  EDITOR_PAGES.includes(page) || subPage === 'editor'

export const coursePath = (courseId, page = 'sections', subPage) =>
  `/mini-course/${courseId}/${page}${subPage ? `/${subPage}` : ''}`

export const editorPath = (courseId, cardId) =>
  `/mini-course/${courseId}/page${cardId ? `/${cardId}` : ''}`
